// deps
import cx from "classnames";
import React, { memo, ReactElement, useMemo } from "react";

// helpers
import { getCloudinaryUrl } from "@core-ui/helpers/Image";

// styles
import styles from "./Spinner.scss";

interface Props {
    isSpinActive: boolean;
    containerClass?: string;
    spinnerClass?: string;
    spinnerSvgClass?: string;
    spinnerBgImgSrc?: string;
    dataTestId?: string;
}

const SPINNER_VIEW_BOX_DIMENSION = 100;
const SPINNER_CENTER_COORDINATE = 50;
const SPINNER_RADIUS = 48;

function Spinner(props: Props): ReactElement {
    const { spinnerClass, spinnerSvgClass, containerClass, isSpinActive, spinnerBgImgSrc, dataTestId } = props;
    const svgClass = cx(
        styles.svg,
        {
            [styles.svgAnimation]: isSpinActive,
        },
        spinnerSvgClass,
    );
    const circleClass = cx(
        styles.svgCircle,
        {
            [styles.svgCircleWithSpin]: isSpinActive,
        },
        spinnerClass,
    );
    const wrapperStyle = useMemo(
        () =>
            spinnerBgImgSrc != null
                ? {
                      backgroundImage: `url(${getCloudinaryUrl(spinnerBgImgSrc, {})})`,
                  }
                : {},
        [spinnerBgImgSrc],
    );

    return (
        <div className={cx(styles.container, containerClass)} data-testid={dataTestId}>
            <div className={styles.wrapper} style={wrapperStyle}>
                <svg className={svgClass} viewBox={`0 0 ${SPINNER_VIEW_BOX_DIMENSION} ${SPINNER_VIEW_BOX_DIMENSION}`}>
                    <circle
                        className={circleClass}
                        cx={`${SPINNER_CENTER_COORDINATE}`}
                        cy={`${SPINNER_CENTER_COORDINATE}`}
                        r={`${SPINNER_RADIUS}`}
                    />
                </svg>
            </div>
        </div>
    );
}

Spinner.defaultProps = {
    isSpinActive: true,
};

export default memo(Spinner);
